<template>
    <div style="display: flex; flex-direction: column; background-color: #fff;">
        <div style="width: 60px; height: 60px; display: flex; justify-content: center; align-items: center;" @click="() => { $GlobalStore.closeLastModal() }">
            <img style="width: 14px;" :src="require('@/assets/img/member_talk_x.png')" alt="">
        </div>
        <div style="flex: 1; padding: 0 20px; overflow-y: scroll; padding-bottom: 30px;">
            <div style="margin-top: 30px; text-align: center;">
                <div style="font-weight: 700; font-size: 32px; line-height: 46px;">멤버톡 만들기</div>
                <div style="margin-top: 16px; line-height: 23px; font-weight: 500;">재밌는 축구를 함께 즐길 수 있습니다.<br>우리만의 팀을 만들어보세요!</div>
            </div>

            <div style="margin-top: 60px;">
                <div class="title">멤버톡의 이름을 입력해주세요</div>
                <input @input="handleTitleLength" v-model="memberTalkInfo.title" placeholder="이름" class="common_input" type="text">
                <div style="font-weight: 700; font-size: 12px; color: #bbbbbb; float: right; margin-top: 6px;">{{ memberTalkInfo.title.length }}/40</div>
            </div>
            <div style="margin-top: 37px;">
                <div class="title">멤버톡을 소개해주세요</div>
                <textarea @input="handleIntroLength" v-model="memberTalkInfo.introduce" placeholder="소개" class="common_text_area" type="text"></textarea>
                <div style="font-weight: 700; font-size: 12px; color: #bbbbbb; float: right; margin-top: 6px;">{{ memberTalkInfo.introduce.length }}/200</div>
            </div>
            <div style="margin-top: 37px;">
                <div class="title">멤버톡 참여 형태를 선택하세요</div>
                <div @click="setEnjoyType(ENJOY_TYPE.ANYBODY)" class="common_box" :style="{ border: memberTalkInfo.enjoy_type === ENJOY_TYPE.ANYBODY ? '1px solid var(--color-main)' : '' }" style="display: flex; gap: 12px; align-items: center; margin-bottom: 12px;">
                    <div>
                        <img style="width: 20px;" :src="require('@/assets/img/anybody_select.png')" alt="">
                    </div>
                    <div>
                        <div style="font-weight: 700; font-size: 14px; margin-bottom: 6px;">누구나 참여 가능</div>
                        <div style="color: #606060; font-weight: 500; font-size: 12px;">누구든 멤버톡에 참여할 수 있습니다.</div>
                    </div>
                </div>
                <div @click="setEnjoyType(ENJOY_TYPE.PRIVATE)" class="common_box" :style="{ border: memberTalkInfo.enjoy_type === ENJOY_TYPE.PRIVATE ? '1px solid var(--color-main)' : '' }" style="display: flex; gap: 12px; align-items: center;">
                    <div>
                        <img style="width: 21px;" :src="require('@/assets/img/private.png')" alt="">
                    </div>
                    <div>
                        <div style="font-weight: 700; font-size: 14px; margin-bottom: 6px;">비공개</div>
                        <div style="color: #606060; font-weight: 500; font-size: 12px;">초대 혹은 비밀번호 입력 시 참여할 수 있습니다.</div>
                    </div>
                </div>
            </div>
        </div>
        <div style="padding-bottom: 40px;">
            <CommonBottomBtn :btnClickEvent="makeMemberTalk" :btnName="'만들기'"></CommonBottomBtn>
        </div>
    </div>
</template>

<script>
import CommonBottomBtn from '@/components/common/CommonBottomBtn.vue';
import { ENJOY_TYPE, JOIN_WAY } from '../../../Constants';
import ResponseCode from '../../../ResponseCode';

export default {
    name: 'MakeMemberTalk',
    components: { CommonBottomBtn },
    data() {
        return {
            memberTalkInfo: {
                title: '',
                introduce: '',
                enjoy_type: null,
            },
            ENJOY_TYPE: ENJOY_TYPE
        }
    },
    created() {
        if (this.$Util.isShowDefaultSettings()) {
            return
        }
    },
    methods: {
        handleTitleLength() {
            if (this.memberTalkInfo.title.length > 40) {
                this.memberTalkInfo.title = this.memberTalkInfo.title.slice(0, 40)
            }
        },
        handleIntroLength() {
            if (this.memberTalkInfo.introduce.length > 200) {
                this.memberTalkInfo.introduce = this.memberTalkInfo.introduce.slice(0, 200)
            }
        },
        setEnjoyType(type) {
            this.memberTalkInfo.enjoy_type = type
        },
        async makeMemberTalk() {
            if (this.memberTalkInfo.title === null || this.memberTalkInfo.title === '') {
                this.$GlobalStore.showAlert('멤버톡의 이름을 입력해주세요.')
                return
            }

            if (this.memberTalkInfo.introduce === null || this.memberTalkInfo.introduce === '') {
                this.$GlobalStore.showAlert('멤버톡의 소개를 입력해주세요.')
                return
            }

            if (this.memberTalkInfo.enjoy_type === null) {
                this.$GlobalStore.showAlert('멤버톡의 참여 형태를 선택해주세요.')
                return
            }

            if (this.memberTalkInfo.enjoy_type === ENJOY_TYPE.ANYBODY) {
                this.memberTalkInfo.enjoy_type = JOIN_WAY.ANYBODY
            } else {
                this.memberTalkInfo.enjoy_type = JOIN_WAY.APPROVE
            }

            const formData = new FormData()
            formData.append('mode', 'insert')
            formData.append('title', this.memberTalkInfo.title)
            formData.append('introduce', this.memberTalkInfo.introduce)
            formData.append('join_way', this.memberTalkInfo.enjoy_type)
            // formData.append('join_tag', null)

            const res = await this.$Axios.post('/api/join/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.showGroupChatting(res.data.chat_idx, res.data.join_idx)
            } else {
                console.log(res)
            }
        },
        async showGroupChatting(chat_idx, join_idx) {
            const isPrivate = this.memberTalkInfo.enjoy_type === JOIN_WAY.APPROVE ? true : false
            const res = await this.$Axios.get('/api/chat/auth', { params: { chat_idx: chat_idx } });
            if (res.data.code === 0) {
                this.$GlobalStore.closeLastModal()
                this.$GlobalStore.addModal('JoinChat', { isNewMemberTalk: isPrivate, auth: res.data.auth, chat: res.data.chat, chatIdx: chat_idx, pTitle: this.memberTalkInfo.title, init_refer_idx: join_idx, completeAction: this.getJoinChats });
            }
        }
    }
}
</script>

<style scoped>
.common_box {
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 12px;
}

.common_input {
    padding: 10px;
    padding-left: 12px;
    outline: none;
    width: 100%;
    border-radius: 12px;
    border: none;
    background-color: #f5f5f5;
}

.common_input::placeholder {
    color: #bbbbbb;
    font-weight: 700;
}

.title {
    font-weight: 500;
    line-height: 23px;
    margin-bottom: 4px;
}

.common_text_area {
    padding: 10px;
    padding-left: 12px;
    outline: none;
    width: 100%;
    min-height: 72px;
    border-radius: 12px;
    border: none;
    resize: none;
    line-height: 23px;
    background-color: #f5f5f5;
}

.common_text_area::placeholder {
    color: #bbbbbb;
    font-weight: 700;
}
</style>